import { queryOptions, infiniteQueryOptions } from '@tanstack/react-query';

import { fetchBucketById, fetchPlaylistById, fetchSection, fetchVideoById } from '@apis/uefatv';
import type { UefatvResponse } from '@shared-types/uefatv.types';

export const getSectionQuery = (section: string, logged: boolean, params?: Record<string, any>) =>
  queryOptions({
    queryKey: ['uefatv-content', section, params, logged],
    queryFn: ({ signal }) => fetchSection({ section }, signal),
  });

export const getSectionQueryPaged = (section: string, logged: boolean, params?: Record<string, any>) =>
  infiniteQueryOptions({
    queryKey: ['uefatv-content', section, params, logged],
    queryFn: ({ pageParam, signal }) => fetchSection({ section, lastSeen: pageParam }, signal),
    initialPageParam: 'empty',
    getNextPageParam: _getNextPage,
  });

export const getPlaylistQuery = (id: string, logged: boolean, rpp?: string) =>
  queryOptions({
    queryKey: ['uefatv-playlist', id, logged, rpp],
    queryFn: ({ signal }) => fetchPlaylistById({ id, rpp }, signal),
  });

export const getBucketQuery = (id: string, logged: boolean, rpp?: string) =>
  queryOptions({
    queryKey: ['uefatv-bucket', id, logged, rpp],
    queryFn: ({ signal }) => fetchBucketById({ bucketId: id, rpp }, signal),
  });

export const getVideoQuery = (id: string, logged: boolean) =>
  queryOptions({
    queryKey: ['uefatv-video', id, logged],
    queryFn: ({ signal }) => fetchVideoById(id, signal),
  });

/**
 * Retrieves the next page parameter for the infinite query.
 * @param lastPage - The last page of the UefatvResponse data.
 * @returns The `exid` of the last bucket in the last page, or `undefined` if there is no more data available.
 */
const _getNextPage = (lastPage: UefatvResponse) => {
  if (!lastPage?.paging?.moreDataAvailable) return undefined;
  return (lastPage?.buckets?.length > 0 && lastPage?.buckets?.[lastPage.buckets.length - 1].exid) ?? undefined;
};
